import React, { useContext } from 'react';

import classes from './YesNoQuestion.module.scss';
import Button from '../../Buttons/Button/Button';
import Context from '../../../store/context';

const YesNoQuestion = ({
  className,
  textButton,
  question,
  acceptHandler,
  classTitle,
  subtitle,
  classIcon,
  Icon,
  backHandler,
  textBackButton
}) => {
  const {
    modal: { hideModal }
  } = useContext(Context);

  const classesContents = [classes['divContent']];

  const noBackHandler = () => {
    if (backHandler) {
      backHandler();
    } else {
      hideModal();
    }
  };

  className && classesContents.push(className);

  return (
    <>
      <div className={classesContents.join(' ')}>
        {Icon && <Icon className={`${classIcon}`} />}
        <span className={`${classTitle} ${classes.question} semibold-18`}>{question}</span>
        <span className={`${classes.subtitle} medium-18`}>{subtitle}</span>
      </div>
      <div className={classes.button}>
        <Button custom='secondary' onClick={noBackHandler}>
          {textBackButton ? textBackButton : 'No, regresar'}
        </Button>
        <Button onClick={acceptHandler}>{textButton}</Button>
      </div>
    </>
  );
};

export default YesNoQuestion;
